import { render, staticRenderFns } from "./UnderDepartmentItem.vue?vue&type=template&id=0b24c75a&scoped=true"
import script from "./UnderDepartmentItem.vue?vue&type=script&lang=js"
export * from "./UnderDepartmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24c75a",
  null
  
)

export default component.exports